import s from './Filter.module.scss';
import FilterState from './FilterState';
import FilterGroup from './FilterGroup';
import FilterItem from './FilterItem';
import SearchTerm from './SearchTerm';

export default function Filter({ schedule, state, onFilter, onClear }) {
  const { tags, genres, locations } = schedule;

  const renderItem = (type, item) => {
    const isActive = item === state[type];

    return (
      <FilterItem
        onClick={() => {
          onFilter(type, isActive ? '' : item);
        }}
        active={isActive}
      >
        {item}
      </FilterItem>
    );
  };

  return (
    <div className={s.wrapper}>
      <FilterState state={state} onClear={onClear} />
      <SearchTerm onFilter={onFilter} />
      <FilterGroup
        title="Browse By Category"
        items={genres}
        renderItem={(item) => renderItem('genre', item)}
      />
      <FilterGroup
        title="Browse By Tag"
        items={tags}
        renderItem={(item) => renderItem('tag', item)}
      />
      <FilterGroup
        title="Browse By Location"
        items={locations}
        renderItem={(item) => renderItem('location', item)}
      />
    </div>
  );
}
